import { practiceAreas } from '@/data/practiceAreas';
import PracticeAreaTemplate from '@/components/PracticeAreaTemplate';

export default function ElderLawPage() {
  return <PracticeAreaTemplate practiceArea={practiceAreas['elder-law']} />;
}
